import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const LOGO_URL = "/creatara-icon.png";

// Send the session_token cookie on every request so Google-OAuth users
// (cookie-based session) can hit JWT-or-cookie protected endpoints.
axios.defaults.withCredentials = true;

// Auto-attach the JWT from localStorage to every outgoing request so the
// newer pages (Videos, Campaigns, Settings/billing-portal, brand-voice,
// branding, api-keys) don't each have to remember to set the header.
// Legacy pages that already set the Authorization header manually
// continue to work — their value wins because we only set if missing.
axios.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("token");
  if (t) {
    cfg.headers = cfg.headers || {};
    if (!cfg.headers.Authorization && !cfg.headers.authorization) {
      cfg.headers.Authorization = `Bearer ${t}`;
    }
  }
  return cfg;
});

export const fadeUp = { hidden: { opacity: 0, y: 20 }, visible: { opacity: 1, y: 0, transition: { duration: 0.5 } } };
export const stagger = { hidden: { opacity: 0 }, visible: { opacity: 1, transition: { staggerChildren: 0.1 } } };
